import Box from '@mui/material/Box';
import { BoxProps } from '@mui/material/Box';
import { forwardRef } from 'react';

const BoxComponent = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return <Box ref={ref} {...props} />;
});

export default BoxComponent;